/**
 * calc-kit — единый набор для детерминированных калькуляторов.
 *
 * Четыре заботы за одним фасадом, один тег на страницу, один вызов init():
 *
 *   1. ВОРОНКА      ready → seen → engaged → result → complete
 *   2. СТРАЖ ПОЛЕЙ  поле и ответ обязаны говорить одно и то же
 *   3. ПРОФИЛЬ      рост/вес/возраст/пол вводятся ОДИН раз на весь набор
 *   4. ВЫДАЧА       ответ можно скопировать и отправить
 *
 * Почему одним модулем, а не четырьмя файлами: каждый отдельный файл — это
 * ещё один <script> в каждом из десяти блейдов, ещё один порядок загрузки,
 * который можно перепутать, и ещё один запрос. Заботы разные, но точка
 * подключения обязана быть одна.
 *
 * Подключение (в блейде тула — ОДНА строка, до инлайнового скрипта):
 *     @include('partials.calc-kit')
 *
 * Использование:
 *     window.__calcKit.init({
 *         root:   '.cu-wrap',
 *         answer: function () { return el.textContent; },   // текущий ответ
 *         meta:   function () { return { cat: 'overweight' }; },
 *         share:  function () { return 'ИМТ 30 — избыточный вес'; }, // необяз.
 *         shareInto: '#bmCard',                              // необяз.
 *     });
 *     __calcKit.feature('units_switch', { to: 'imperial' });
 *
 * Профиль подключается РАЗМЕТКОЙ, без кода:
 *     <input id="bmW" data-profile="weightKg" …>
 *
 * Слаг берётся из <meta name="tool-slug">, подписи — из window.__calcKitL10n.
 */
(function () {
    'use strict';
    if (window.__calcKit) return;

    /* ─────────────────────────── общее ─────────────────────────── */

    var SCOPE = '.cu-wrap';
    var RESULT_DEBOUNCE_MS = 700;   // короче — ловим промежуточные «9» из «95»
    var PROFILE_KEY = 'tmb_calc_profile';

    function L(key, fallback) {
        var d = window.__calcKitL10n || {};
        return d[key] || fallback || '';
    }
    function slugOf() {
        var m = document.querySelector('meta[name="tool-slug"]');
        return m ? m.content : null;
    }
    function ae(type, payload) {
        if (typeof window.__ae === 'function') {
            try { window.__ae(type, payload || {}); } catch (e) {}
        }
    }
    function num(v) {
        var n = parseFloat(v);
        return isFinite(n) ? n : null;
    }
    function emitInput(el) {
        try {
            el.dispatchEvent(new Event('input', { bubbles: true }));
        } catch (e) {
            var ev = document.createEvent('Event');
            ev.initEvent('input', true, false);
            el.dispatchEvent(ev);
        }
    }

    /* `window.__stage` создаёт telemetry-tier0 после разрешения согласия,
       то есть ПОЗЖЕ, чем инлайновый скрипт тула зовёт init(). Прямой вызов
       на этом месте молча терял первую стадию — в замере воронка начиналась
       с `∅→seen` вместо `∅→ready`. Поэтому ранние стадии копятся и уходят,
       как только примитив появился. */
    var _pending = [];
    function flushPending() {
        if (typeof window.__stage !== 'function' || !_pending.length) return;
        var q = _pending; _pending = [];
        for (var i = 0; i < q.length; i++) {
            try { window.__stage(q[i][0], q[i][1]); } catch (e) {}
        }
    }
    function stage(name, meta) {
        if (typeof window.__stage === 'function') {
            flushPending();
            try { window.__stage(name, meta || {}); } catch (e) {}
            return;
        }
        if (_pending.length < 8) _pending.push([name, meta || {}]);
        if (_pending.length === 1) {
            var tries = 0;
            var iv = setInterval(function () {
                if (typeof window.__stage === 'function' || ++tries > 40) {
                    clearInterval(iv);
                    flushPending();
                }
            }, 100);
        }
    }

    /* ──────────────────── 2. СТРАЖ ПОЛЕЙ ───────────────────────────
     *
     * `min`/`max` на <input type=number> НЕ мешают ввести что угодно —
     * браузер проверяет их только при отправке формы, а форм тут нет.
     * /bmi-calculator на «999 см, 99999 кг» уверенно отвечал «ИМТ 1 002 —
     * ожирение III степени» и советовал дефицит калорий человеку весом
     * 97 тонн. Настоящая причина такого ввода — опечатка, а ответ на
     * опечатку хуже отказа. Пустое поле у /glycemic-index молча
     * заменялось умолчанием: в поле «», на экране «В 150 г».
     *
     * Правка в два РАЗНЫХ момента, потому что стороны не равнозначны:
     *   • СРАЗУ на вводе: `> max` → max. Перебрать потолок можно только
     *     опечаткой (1780 вместо 178).
     *   • При уходе с поля: пусто → значение из атрибута `value`, если оно
     *     есть; `< min` → min. Нижнюю границу на вводе трогать НЕЛЬЗЯ: по
     *     дороге к «178» поле проходит через «1» и «17».
     *
     * ⚠️ Поля БЕЗ атрибута `value` (необязательный обхват талии) при
     * очистке остаются пустыми — «не указано» там законный ответ.
     */
    /* Поле со своим хозяином проверки (data-own-guard — например, возраст
       через window.__ageField) страж не трогает: прижатое к max значение
       скрыло бы от человека, что он вышел за диапазон тула. */
    function guardCap(el) {
        if (!el || el.tagName !== 'INPUT' || el.type !== 'number') return;
        if (el.hasAttribute('data-own-guard')) return;
        if (!el.closest || !el.closest(SCOPE)) return;
        var max = num(el.getAttribute('max'));
        var v = num(el.value);
        if (max === null || v === null || v <= max) return;
        el.value = String(max);
        emitInput(el);
        Kit.invalid('above:' + (el.id || '?'));
    }

    function guardFix(el) {
        if (!el || el.tagName !== 'INPUT' || el.type !== 'number') return;
        if (el.hasAttribute('data-own-guard')) return;
        if (!el.closest || !el.closest(SCOPE)) return;

        var min = num(el.getAttribute('min'));
        var max = num(el.getAttribute('max'));
        var raw = String(el.value == null ? '' : el.value).trim();
        var reason = null, next = null;

        if (raw === '') {
            var def = el.getAttribute('value');
            if (def !== null && def !== '') { next = def; reason = 'empty'; }
        } else {
            var v = num(raw);
            if (v === null) {
                var d2 = el.getAttribute('value');
                if (d2 !== null && d2 !== '') { next = d2; reason = 'nan'; }
            } else if (min !== null && v < min) { next = String(min); reason = 'below'; }
            else if (max !== null && v > max) { next = String(max); reason = 'above'; }
        }

        if (next === null || next === raw) return;
        el.value = next;
        emitInput(el);
        Kit.invalid(reason + ':' + (el.id || '?'));
    }

    /* ──────────────────── 3. ПРОФИЛЬ ───────────────────────────────
     *
     * Рост, вес, возраст и пол спрашивают пять тулов набора из десяти
     * (вес — 5, рост — 3, пол — 4, возраст — 2). Раньше каждый хранил их
     * у себя через __toolSettings, и человек, перешедший с /bmi-calculator
     * на /water-intake, вводил вес заново.
     *
     * Хранится в КАНОНИЧЕСКИХ единицах (см и кг): тул с переключателем
     * дюймов конвертирует сам, и профиль не зависит от того, в каких
     * единицах его последний раз ввели.
     *
     * ⚠️ Заполняется ТОЛЬКО поле, которого человек не трогал (пустое или
     * равное своему атрибуту `value`). Подставить поверх набранного —
     * значит подменить данные под рукой у пользователя.
     *
     * ⚠️ И это заметно: рост с весом — не настройка интерфейса, а сведения
     * о теле. Поэтому подстановка не молчаливая: под полями появляется
     * строка о том, откуда взялись числа, и кнопка «Забыть».
     */
    var FIELDS = { sex: 1, age: 1, heightCm: 1, weightKg: 1 };

    function profileRead() {
        try {
            var raw = localStorage.getItem(PROFILE_KEY);
            if (!raw) return {};
            var o = JSON.parse(raw);
            return (o && typeof o === 'object') ? o : {};
        } catch (e) { return {}; }
    }
    function profileWrite(patch) {
        try {
            var o = profileRead();
            for (var k in patch) if (FIELDS[k] && patch[k] != null) o[k] = patch[k];
            o.v = 1;
            localStorage.setItem(PROFILE_KEY, JSON.stringify(o));
        } catch (e) {}
    }
    function profileClear() {
        try { localStorage.removeItem(PROFILE_KEY); } catch (e) {}
    }

    /** Значение поля в канонических единицах (см/кг). */
    function toCanonical(el, v) {
        var u = (el.getAttribute('data-profile-unit') || '').toLowerCase();
        if (u === 'in') return v * 2.54;
        if (u === 'lb') return v * 0.45359237;
        return v;
    }
    function fromCanonical(el, v) {
        var u = (el.getAttribute('data-profile-unit') || '').toLowerCase();
        if (u === 'in') return v / 2.54;
        if (u === 'lb') return v / 0.45359237;
        return v;
    }
    function untouched(el) {
        var raw = String(el.value == null ? '' : el.value).trim();
        if (raw === '') return true;
        var def = el.getAttribute('value');
        return def !== null && raw === String(def).trim();
    }

    function profileInit(root) {
        var nodes = [].slice.call(root.querySelectorAll('[data-profile]'));
        if (!nodes.length) return;
        var saved = profileRead();
        var filled = [];

        nodes.forEach(function (el) {
            var key = el.getAttribute('data-profile');
            if (!FIELDS[key]) return;

            if (saved[key] != null && untouched(el)) {
                var v = saved[key];
                if (el.tagName === 'SELECT') {
                    var has = [].some.call(el.options, function (o) { return o.value === String(v); });
                    if (has) { el.value = String(v); filled.push(el); }
                } else {
                    var out = fromCanonical(el, Number(v));
                    // Шаг поля задаёт разумную точность: 0,1 кг, но не 0,4536.
                    var step = num(el.getAttribute('step')) || 1;
                    var dec = String(step).indexOf('.') >= 0 ? String(step).split('.')[1].length : 0;
                    el.value = String(Number(out.toFixed(dec)));
                    filled.push(el);
                }
            }

            el.addEventListener('change', function () {
                /* Тул может на время отключить запись: /bmi-calculator в
                   детском режиме ставит data-profile-off, иначе рост и вес
                   ребёнка заменили бы в профиле числа родителя. */
                if (el.closest && el.closest('[data-profile-off]')) return;
                var patch = {};
                if (el.tagName === 'SELECT') patch[key] = el.value;
                else {
                    var n = num(el.value);
                    if (n !== null) patch[key] = Math.round(toCanonical(el, n) * 100) / 100;
                }
                profileWrite(patch);
            });
        });

        if (filled.length) {
            filled.forEach(function (el) { emitInput(el); });
            showProfileNote(filled[filled.length - 1], nodes);
            Kit.feature('profile_fill', { n: filled.length });
        }
    }

    function showProfileNote(afterEl, nodes) {
        var field = afterEl.closest('.cu-field') || afterEl.parentElement;
        if (!field || document.getElementById('calcKitProfileNote')) return;
        var box = document.createElement('div');
        box.id = 'calcKitProfileNote';
        box.className = 'cu-fhint calc-kit-note';
        box.setAttribute('role', 'status');
        var span = document.createElement('span');
        span.textContent = L('profile_filled', 'Ваши данные подставлены из прошлых расчётов.') + ' ';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'calc-kit-forget';
        btn.textContent = L('profile_forget', 'Забыть');
        btn.addEventListener('click', function () {
            profileClear();
            nodes.forEach(function (el) {
                var def = el.getAttribute('value');
                if (el.tagName !== 'SELECT' && def !== null) { el.value = def; emitInput(el); }
            });
            box.textContent = L('profile_forgotten', 'Данные забыты.');
            Kit.feature('profile_forget', {});
        });
        box.appendChild(span);
        box.appendChild(btn);
        field.parentNode.insertBefore(box, field.nextSibling);
    }

    /* ──────────────────── 4. ВЫДАЧА РЕЗУЛЬТАТА ─────────────────────
     *
     * Ни один тул набора не давал скопировать или отправить ответ, хотя
     * на телефоне это первый жест после того, как ответ получен.
     *
     * ⚠️ Копируется ССЫЛКА И ОТВЕТ, именно в таком порядке, и это не
     * оформление. telemetry-tier0 считает копирование завершением работы
     * («скопированный текст И ЕСТЬ результат» — верно для генераторов
     * пароля или хеша), но делает ровно одно исключение: текст, который
     * НАЧИНАЕТСЯ со своего origin, — это «поделиться», а не продукт тула.
     * У калькулятора завершение уже засчитано по показанному ответу, и
     * вторая отметка за сессию завысила бы долю успеха. Ссылка первой
     * строкой попадает под это исключение по существу, а не в обход: в
     * чат вставляют именно «ссылка + что получилось».
     */
    /** Текст выдачи. Для буфера — со ссылкой первой строкой (см. выше);
        системному «Поделиться» ссылка передаётся отдельным полем. */
    function shareText(cfg, withLink) {
        var t = '';
        try { t = String(cfg.share() || '').trim(); } catch (e) {}
        if (!t) return '';
        return withLink ? (location.href + '\n' + t) : t;
    }

    function shareInit(cfg, root) {
        if (typeof cfg.share !== 'function') return;
        var host = cfg.shareInto
            ? (typeof cfg.shareInto === 'string' ? root.querySelector(cfg.shareInto) : cfg.shareInto)
            : null;
        if (!host) return;

        var bar = document.createElement('div');
        bar.className = 'calc-kit-actions';

        var copy = document.createElement('button');
        copy.type = 'button';
        copy.className = 'calc-kit-btn';
        copy.setAttribute('data-act', 'copy');
        copy.textContent = L('copy', 'Скопировать');
        copy.addEventListener('click', function () {
            var text = shareText(cfg, true);
            if (!text) return;
            var done = function () {
                copy.textContent = L('copied', 'Скопировано');
                setTimeout(function () { copy.textContent = L('copy', 'Скопировать'); }, 1600);
                Kit.feature('copy', { chars: text.length });
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(text).then(done, function () {
                    if (window.__toast) window.__toast(L('copy_failed', 'Не удалось скопировать'), 'error');
                });
            } else if (window.__toast) {
                window.__toast(L('copy_failed', 'Не удалось скопировать'), 'error');
            }
        });
        bar.appendChild(copy);

        // Системный «Поделиться» есть не везде; кнопка появляется только там,
        // где ей есть что вызвать, — пустая кнопка хуже её отсутствия.
        if (navigator.share) {
            var share = document.createElement('button');
            share.type = 'button';
            share.className = 'calc-kit-btn';
            share.setAttribute('data-act', 'share');
            share.textContent = L('share', 'Поделиться');
            share.addEventListener('click', function () {
                var text = shareText(cfg, false);
                if (!text) return;
                navigator.share({ text: text, url: location.href })
                    .then(function () { Kit.feature('share', {}); })
                    .catch(function () { /* отмена пользователем — не ошибка */ });
            });
            bar.appendChild(share);
        }

        host.appendChild(bar);
    }

    /* ──────────────────── 1. ВОРОНКА + фасад ───────────────────────── */

    var Kit = {
        _slug: null, _seenFired: false, _engaged: false,
        _lastAnswer: null, _results: 0, _features: {}, _timer: null, _t0: 0, _invalid: null,

        init: function (cfg) {
            cfg = cfg || {};
            var self = this;
            this._slug = cfg.slug || slugOf();
            if (!this._slug) return this;
            this._answerFn = typeof cfg.answer === 'function' ? cfg.answer : null;
            this._metaFn = typeof cfg.meta === 'function' ? cfg.meta : null;
            this._t0 = Date.now();

            var root = typeof cfg.root === 'string' ? document.querySelector(cfg.root) : (cfg.root || null);
            this._root = root || document.querySelector('.tool-page-slot') || document.body;

            stage('ready', { kind: 'calc' });

            /* «Дошёл до калькулятора» — отдельный факт. На iPhone первое поле
               ввода лежит в 1,5–1,7 высоты экрана от верха (замер по десяти
               тулам), потому что по правилу проекта инструкция стоит выше
               рабочей области. Без этого события «посмотрел и ушёл»
               неотличимо от «не долистал».
               ⚠️ Порог ИМЕННО НОЛЬ: с 0.35 событие не приходило у тулов, чей
               блок выше экрана телефона, — наблюдатель молчал, а выглядело
               это как «человек не долистал». */
            if (window.IntersectionObserver) {
                var io = new IntersectionObserver(function (entries) {
                    for (var i = 0; i < entries.length; i++) {
                        if (entries[i].isIntersecting && !self._seenFired) {
                            self._seenFired = true;
                            io.disconnect();
                            ae('feature_use', {
                                slug: self._slug, action: 'tool_seen',
                                ms: Date.now() - self._t0, scrolled: Math.round(window.scrollY),
                            });
                            stage('seen', {});
                        }
                    }
                }, { threshold: 0 });
                try { io.observe(this._root); } catch (e) {}
            }

            var onInput = function () {
                if (!self._engaged) {
                    self._engaged = true;
                    stage('engaged', { ms: Date.now() - self._t0 });
                    ae('feature_use', { slug: self._slug, action: 'engage', ms: Date.now() - self._t0 });
                }
                self._scheduleResult();
            };
            this._root.addEventListener('input', onInput, true);
            this._root.addEventListener('change', onInput, true);
            this._root.addEventListener('click', function (e) {
                var t = e.target;
                if (t && t.closest && t.closest('button')) onInput();
            }, true);

            profileInit(this._root);
            shareInit(cfg, this._root);

            /* Флаг наружу: «модуль есть на странице» и «модуль запущен» —
               РАЗНЫЕ факты. Порядок тега и инлайнового скрипта тула уже
               разъезжался однажды, и на глаз это неотличимо от рабочей
               страницы. Проверять надо запуск, а не наличие файла. */
            this.inited = true;

            // Стартовый ответ — не результат работы человека, только помним.
            setTimeout(function () { self._lastAnswer = self._read(); }, 0);
            return this;
        },

        _read: function () {
            if (!this._answerFn) return null;
            try {
                var v = this._answerFn();
                return v == null ? null : String(v).replace(/\s+/g, ' ').trim();
            } catch (e) { return null; }
        },

        _scheduleResult: function () {
            var self = this;
            if (this._timer) clearTimeout(this._timer);
            this._timer = setTimeout(function () { self._reportResult(); }, RESULT_DEBOUNCE_MS);
        },

        /* Единица — ПОКАЗАННЫЙ ответ, а не нажатие. Пока человек печатает
           «95», поле проходит через «9» и «95»; дедуп по тексту ответа
           оставляет одно событие на каждый РАЗЛИЧНЫЙ ответ. */
        _reportResult: function () {
            var a = this._read();
            if (!a || a === this._lastAnswer) return;
            this._lastAnswer = a;
            this._results++;

            var payload = { slug: this._slug, kind: 'calc', n: this._results, ms: Date.now() - this._t0 };
            if (this._metaFn) {
                try {
                    var m = this._metaFn() || {};
                    for (var k in m) if (Object.prototype.hasOwnProperty.call(m, k)) payload[k] = m[k];
                } catch (e) {}
            }
            stage('result', { n: this._results });

            /* ⚠️ `tool_complete` — РОВНО ОДИН за сессию, на первый настоящий
               ответ. Панель считает долю успеха как completes / (completes +
               errors + abandons): у калькулятора, который пересчитывает на
               лету, каждый следующий ответ давал бы ещё одно «завершение».
               Замер до правки: один человек, один ввод роста и веса и две
               правки веса — ЧЕТЫРЕ `tool_complete`. */
            if (this._results === 1) {
                if (typeof window.__aeToolComplete === 'function') {
                    try { window.__aeToolComplete(payload); } catch (e) { ae('tool_complete', payload); }
                } else {
                    ae('tool_complete', payload);
                }
            } else {
                ae('feature_use', { slug: this._slug, action: 'refine', n: this._results, ms: payload.ms });
            }
        },

        /** Функция тула использована. Одно событие на имя за жизнь страницы. */
        feature: function (name, data) {
            if (!this._slug || !name || this._features[name]) return;
            this._features[name] = 1;
            var p = { slug: this._slug, action: name };
            if (data) for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) p[k] = data[k];
            ae('feature_use', p);
        },

        /** Ввод пришлось поправить: узнаём, как часто и куда промахиваются. */
        invalid: function (reason) {
            if (!this._slug || this._invalid === reason) return;
            this._invalid = reason;
            ae('feature_use', { slug: this._slug, action: 'invalid_input', reason: String(reason).slice(0, 40) });
        },

        profile: { get: profileRead, set: profileWrite, clear: profileClear },
    };

    function attachGuard() {
        document.addEventListener('input', function (e) { guardCap(e.target); }, true);
        document.addEventListener('change', function (e) { guardFix(e.target); }, true);
        // На iOS пикер числа может не дать `change` при уходе тапом мимо.
        document.addEventListener('blur', function (e) { guardFix(e.target); }, true);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', attachGuard);
    } else {
        attachGuard();
    }

    window.__calcKit = Kit;
})();
